// pure helpers for the teacher "Payment details" page (moved off the teacher profile).
import { hasAccess } from '../../../../util_functions';

export const PAYMENT_DETAILS_PATH = '/teacherprofile/payment-details';

export const payment_details_url = (uuid) =>
  `${PAYMENT_DETAILS_PATH}?id=${encodeURIComponent(uuid)}`;

const PAYMENT_ROLES = ['SUPER_USER', 'TEACHER_OPS_PAYMENT', 'TEACHER_PAYMENT_SUPER_USER'];

// In only through TEACHER_ONBOARDING: the page is limited to Profile Live At and the base rate.
export const is_onboarding_only = (access_type) =>
  hasAccess(access_type, 'TEACHER_ONBOARDING') && !hasAccess(access_type, ...PAYMENT_ROLES);

// Mirrors the server's Payment details grant (payment roles + onboarding); access_type is a comma-joined SET.
export const can_see_payment_details = (access_type) =>
  hasAccess(access_type, ...PAYMENT_ROLES, 'TEACHER_ONBOARDING');

export const teacher_profile_url = (uuid) => `/teacherprofile?id=${encodeURIComponent(uuid)}`;

export const teacher_id_from_search = (search) => {
  const id = new URLSearchParams(search || '').get('id');
  return id ? id.trim() : '';
};

export const teacher_display_name = (details) =>
  `${details?.first_name || ''} ${details?.last_name || ''}`.trim();

// Redux holds one shared teacher profile; it is only usable when it is this teacher's.
export const profile_for = (details, uuid) =>
  details && uuid && details.uuid === uuid ? details : null;

// Fetch once per id, and not while another teacher's fetch is in flight (it would overwrite ours).
export const needs_profile_fetch = ({ details, status, uuid, fetched_for }) =>
  !!uuid && !profile_for(details, uuid) && status !== 'loading' && fetched_for !== uuid;

// 'invalid' | 'loading' | 'error' | 'ready'. Our fetch settled without this teacher = error, not a spinner.
export const page_state = ({ details, status, uuid, fetched_for }) => {
  if (!uuid) return 'invalid';
  if (profile_for(details, uuid)) return 'ready';
  if (fetched_for === uuid && status !== 'loading') return 'error';
  return 'loading';
};
